export default __webpack_public_path__ + "static/media/pic-2.0593bc2f.jpg";